import React from 'react';
import moment from 'moment';
import Icon from '@ant-design/icons';

import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { DATE_ONLY_MONTH_FORMAT } from '@share/constants';
import { DATE_FORMAT } from '@share/constants';
import { getSelectedMonthText } from '@share/utils';
import { LocationGreySvg, CondoSvg } from '@share/assets';
import { SearchHandlerArgs } from '@common-types';
import { CondoLocationsEnum, IAccount, ICondoRecentSearches, StayForEnum } from '@share/common-types';
import { formatDateCheckInOut } from '@share/utils';

import './style.scss';
import { isEmpty } from 'lodash';
import arrow from '@assets/images/gallery/right-arrow.svg';

interface IProps extends WrappedComponentProps {
  data: ICondoRecentSearches;
  disabled: boolean;
  account: IAccount;

  onSearchHandler: SearchHandlerArgs;
}

const ONE = 1;

class CondoRecentSearchesComponent extends React.Component<IProps> {
  render(): React.ReactNode {
    const { data, disabled, account, onSearchHandler, intl } = this.props;
    const {
      months,
      checkIn,
      checkOut,
      location,
      searchType,
      adultsCount,
      stayDuration,
      childrenCount,
      bedroomsCount,
      includeStudio,
    } = data;
    const guestsInfo = {
      adultsCount,
      bedroomsCount,
      kidsCount: childrenCount,
      includeStudio,
    };

    const isGenericRegion = location.locationType === CondoLocationsEnum.GenericRegion;
    const formattedMonths = months?.map((month: any) => moment(month, 'yyyy-MM-DD').format('DD MMM yyyy'));
    const formattedStartDate = checkIn && formatDateCheckInOut(checkIn, DATE_ONLY_MONTH_FORMAT);
    const formattedEndDate = checkOut && formatDateCheckInOut(checkOut, DATE_FORMAT);

    const generalBorderRadius: any = account?.generalBorderRadius ? account?.generalBorderRadius : null;
    const style = !isEmpty(generalBorderRadius) ? { borderRadius: generalBorderRadius } : {};  
    const color: any = account?.searchIconsColor;
    const styleColor = !isEmpty(color) ? { color } : {};
    const buttonColor = account?.buttonColor;

    return (
      <div
        role="button"
        className={`recent-searches-picker border-1 card shadow-sm ${disabled ? 'disabled' : ''}`}
        style={style}
        onClick={() =>{
          if (!disabled) {
            onSearchHandler(
              location,
              searchType,
              stayDuration as StayForEnum,
              guestsInfo,
              formattedMonths,
              checkIn,
              checkOut,
            );
          }
        }}
      >

        {/* <Icon component={isGenericRegion ? LocationGreySvg : CondoSvg} /> */}
        <div className="recent-searches-picker__info">
          <h6 className="d-flex align-items-start search-title mt-1 mb-2">
             <em className='fas fa-map-marker-alt fs-8 me-3 location-icon' style={{ ...styleColor }}></em>
             <p className="recent-searches-picker__title mb-0">{location.name + (!location.region ? '' : ', ' + location.region)}</p>
          </h6>
          <h6 className="d-flex align-items-start mt-1 mb-2 search-subtitle">
            <em className="fas fa-calendar fs-8 me-3 location-icon" style={{ ...styleColor }}></em>
            <p className="recent-searches-picker__subtitle ttl mb-0">
                {checkIn ? (
                  <span>
                    {formattedStartDate} - {formattedEndDate}
                  </span>
                ) : (
                  <>
                    {ONE} <FormattedMessage id="week" values={{ count: ONE }} />{' '}
                    {formattedMonths?.length ? (
                      <span>
                        <FormattedMessage id="in" /> {getSelectedMonthText(formattedMonths, intl)}
                      </span>
                    ) : (
                      <span>
                        <FormattedMessage id="anytime" />
                      </span>
                    )}
                  </>
                )}
              </p>
          </h6>
          <h6 className="d-flex align-items-start mt-1 mb-2 pb-4 search-subtitle">
            <em className="fas fa-user-friends fs-8 me-3 location-icon" style={{ ...styleColor }} ></em>
            <p className="recent-searches-picker__subtitle mb-0">
            {adultsCount} <FormattedMessage id="adult" values={{ count: adultsCount }} />,{' '}
            {!!childrenCount && (
              <>
                {childrenCount} <FormattedMessage id="child" values={{ count: childrenCount }} />,{' '}
              </>
            )}
            {!guestsInfo?.includeStudio ? (
              <>
                {bedroomsCount} <FormattedMessage id="bedroom" values={{ count: bedroomsCount }} />
              </>) : (
              <>
                <FormattedMessage id="Studio" />
              </>)}
          </p>
          </h6>
      

          <div className={`search-again secondary-font ${disabled ? 'disabled' : ''}`} style={{color: `${buttonColor}`}}>
            <FormattedMessage id="availability.status.modal.search_again" />
            <img src={arrow} width={25} className="mx-2" />
            {/* <FontAwesomeIcon icon={faArrowRight} /> */}
          </div>
        </div>
      </div>
    );
  }
}

export const CondoRecentSearches = injectIntl(CondoRecentSearchesComponent);
